/**
 * Simple logger - only logs in development
 */
class Logger {
  private isDev = typeof import.meta !== 'undefined' && (import.meta as { env?: { DEV?: boolean } }).env?.DEV;

  log(message: string, ...args: unknown[]): void {
    if (this.isDev) console.log(message, ...args);
  }
  info(message: string, ...args: unknown[]): void {
    if (this.isDev) console.info(message, ...args);
  }
  warn(message: string, ...args: unknown[]): void {
    if (this.isDev) console.warn(message, ...args);
  }
  error(message: string, error?: unknown, ...args: unknown[]): void {
    console.error(message, error, ...args);
  }
  debug(message: string, ...args: unknown[]): void {
    if (this.isDev) console.debug(message, ...args);
  }
}

export const logger = new Logger();
